import {
    CashierStepDescriptionStyled,
    CashierStepStatusStyled,
    CashierStepStyled,
    CashierStepTitleStyled
} from "./styled/CashierStepStyled";
import React from "react";
import { CASHIER_STEP_CONFIG, CASHIER_STEP_STATUSES } from "./cashierStepsConstants";
import { BinIcon } from "../../../../components/icon/Icon";
import classNames from "classnames";

function CashierStep(props) {
    const {description, status, title} = props;
    const {iconName, iconColor} = CASHIER_STEP_CONFIG[status] || {};

    return <CashierStepStyled className={classNames({'in-progress': status === CASHIER_STEP_STATUSES.IN_PROGRESS})}>
        <CashierStepStatusStyled>
            <BinIcon name={iconName} style={{fill: iconColor}}/>
        </CashierStepStatusStyled>
        <div className={'d-flex flex-column'}>
            <CashierStepTitleStyled>
                {title}
            </CashierStepTitleStyled>
            {!!description && <CashierStepDescriptionStyled>
                {description}
            </CashierStepDescriptionStyled>}
        </div>
    </CashierStepStyled>
}

export default CashierStep;
